import { Check } from "lucide-react";

// Generic multi-select "checkbox card" question. Options come from the backend
// (protocol focuses, spa services, …) — nothing source-specific lives here.
export function MultiSelectCardsQuestion({ question, value = [], onChange, index }) {
  const toggle = (id) => onChange(value.includes(id) ? value.filter((v) => v !== id) : [...value, id]);
  const fmtPrice = (p) => (p == null ? "" : `$${Number(p).toFixed(Number(p) % 1 ? 2 : 0)}`);
  return (
    <section className="space-y-4" data-testid={`form-question-${question.key}`}>
      <div className="flex items-start gap-3">
        <span className="mt-0.5 inline-flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-[#0b2545] text-xs font-bold text-white">{index + 1}</span>
        <div>
          <h2 className="text-base md:text-lg font-semibold text-[#0b2545]" data-testid={`form-question-text-${question.key}`}>{question.text}</h2>
          <p className="text-xs text-zinc-500 mt-0.5">Select all that apply{value.length ? ` · ${value.length} selected` : ""}</p>
        </div>
      </div>
      {question.options.length === 0 ? (
        <p className="rounded-xl border border-dashed border-zinc-300 bg-white/60 px-4 py-6 text-center text-sm text-zinc-500" data-testid={`form-question-empty-${question.key}`}>
          No options have been configured for this question yet.
        </p>
      ) : (
        <ul className="grid grid-cols-1 sm:grid-cols-2 gap-3">
          {question.options.map((o) => {
            const on = value.includes(o.id);
            return (
              <li key={o.id}>
                <button type="button" onClick={() => toggle(o.id)} aria-pressed={on}
                  className={`group w-full text-left rounded-2xl border p-4 flex gap-3 transition-[border-color,background-color,transform] duration-150 active:scale-[0.99] ${on ? "border-[#b88a2b] bg-[#fbf7ee] shadow-sm" : "border-zinc-200 bg-white hover:border-zinc-300"}`}
                  data-testid={`form-option-${o.id}`}>
                  {o.image_url && <img src={o.image_url} alt="" className="h-14 w-14 rounded-xl object-cover bg-zinc-100 shrink-0" loading="lazy" />}
                  <div className="min-w-0 flex-1">
                    <div className="flex items-start justify-between gap-2">
                      <span className="font-semibold text-sm text-[#0b2545] leading-snug">{o.label}</span>
                      <span className={`mt-0.5 inline-flex h-5 w-5 shrink-0 items-center justify-center rounded-full border transition-colors ${on ? "border-[#b88a2b] bg-[#b88a2b] text-white" : "border-zinc-300 bg-white text-transparent"}`}>
                        <Check size={12} strokeWidth={3} />
                      </span>
                    </div>
                    {(o.price != null || o.duration) && (
                      <div className="text-xs text-zinc-600 mt-0.5">{[fmtPrice(o.price), o.duration ? `${o.duration} min` : ""].filter(Boolean).join(" · ")}</div>
                    )}
                    {o.description && <p className="text-xs text-zinc-500 mt-1 line-clamp-2">{o.description}</p>}
                  </div>
                </button>
              </li>
            );
          })}
        </ul>
      )}
    </section>
  );
}

// Registry: new question types plug in here without touching the engine.
export const QUESTION_RENDERERS = {
  multi_select_cards: MultiSelectCardsQuestion,
};
